module.exports = __webpack_public_path__ + "img/Icon-Hash-Protected.e8f87ef6.svg";